import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LOVE_PHRASES } from '../../config/phrases';

const RotatingPhrases = () => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPhraseIndex((prevIndex) =>
        prevIndex === LOVE_PHRASES.length - 1 ? 0 : prevIndex + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-[120px] mt-12 flex items-center justify-center bg-white/5 backdrop-blur-sm rounded-lg">
      <AnimatePresence mode="wait">
        <motion.p
          key={currentPhraseIndex}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.5 }}
          className="text-lg md:text-xl text-gray-600 font-serif italic max-w-2xl px-4"
        >
          "{LOVE_PHRASES[currentPhraseIndex]}"
        </motion.p>
      </AnimatePresence>
    </div>
  );
};

export default RotatingPhrases; 